export const ENRICH_FIELDS = {
  EMAIL: "email",
  PHONE: "phone",
};

export const REQUEST_ID_ALIASES = ["enrichment_request_id", "vendor_request_id", "async_request_id"];

export const MAX_SELECTION_LIMIT = 5000;

export const FIND_TABS = [
  { title: "Search with filters" },
  { title: "Search with AI" },
  { title: "Saved Search" },
];

export const BULK_ACTION_SUCCESS_MESSAGES = {
  primary: { lead: "Successfully added to leads", company: "Successfully added to companies" },
};

export const BULK_ACTION_ERROR_MESSAGES = {
  list: "Failed to add to list. Please try again.",
  sequence: "Failed to add to sequence. Please try again.",
  primary: "Failed to add. Please try again.",
};

export const MAX_DOMAIN_LIMIT = 500;

export const entityMessages = {
  contact: {
    page: "Contacts",
    plural: "contacts are added ",
    singular: "contact is added ",
    route: "/contacts",
  },
  company: {
    page: "Companies",
    plural: "companies are added ",
    singular: "company is added ",
    route: "/companies",
  },
  lead: {
    page: "Leads",
    plural: "leads are added ",
    singular: "lead is added ",
    route: "/leads",
  },
  list: {
    page: "List",
    content: "to list ",
    route: "/list/",
  },
  sequence: {
    page: "Sequence",
    content: "to sequence ",
    route: "/sequences/",
  },
  description: "successfully!",
};
